(function ($, Drupal) {
  'use strict';

  $.expr[":"].text = jQuery.expr.createPseudo(function (arg) {
    return function (elem) {
      return $(elem).text() == arg;
    };
  });

  $.expr[':'].contains = function (a, i, m) {
    return jQuery(a).text().toUpperCase()
      .indexOf(m[3].toUpperCase()) >= 0;
  };

  // global vars
  var medium = 641;
  var desktop = 1024;
  var pfx = ["webkit", "moz", "MS", "o", ""];


  Drupal.behaviors.nsb = {
    attach: function (context, settings) {

      var cmSettings = $('.cmd-privacy-settings');
      var klaroCookie = Cookies.get('klaro');
      if (klaroCookie !== undefined) {
        cmSettings.fadeIn();
      }
      $(document).on('click touch', '.cm-footer-buttons, .cm-bg', function (e) {
        window.setTimeout(function () {
          klaroCookie = Cookies.get('klaro');
          if (klaroCookie !== undefined) {
            if ($(e.target).hasClass('cm-btn-accept-all') || $(e.target).hasClass('cm-btn-accept') || $(e.target).hasClass('cm-btn-decline') || $(e.target).hasClass('cm-bg')) {
              cmSettings.fadeIn();
            }
          }
        }, 1000);
      });

      $(document).on('click touch', '.cmd-privacy-settings', function (e) {
        if ($('.cm-footer-buttons:visible').length > 0) {
          cmSettings.fadeOut();
        }
      });

      $('.overlayerSelector').hide();

      //-------selectbox --------------------------

      var select = $('select:not(.select-hidden):not(#edit-aktions-ort):not(.shs-select)').not("[multiple=multiple]").not('.shs-processed');
      if (select.length > 0) {
        $(select).each(function () {
          var $this = $(this), numberOfOptions = $(this).children('option').length;

          $this.addClass('select-hidden');
          $this.wrap('<div class="select"></div>');
          $this.after('<div class="select-styled"></div>');

          var $styledSelect = $this.next('div.select-styled');
          $styledSelect.text($this.children('option[selected=selected]').eq(0).text());

          var $list = $('<ul />', {
            'class': 'select-options'
          }).insertAfter($styledSelect);

          for (var i = 0; i < numberOfOptions; i++) {
            $('<li />', {
              text: $this.children('option').eq(i).text(),
              rel: $this.children('option').eq(i).val()
            }).appendTo($list);
          }

          // Inline search for long option lists.
          var $searchItem = $();
          var $searchInput = $();
          if (numberOfOptions > 8) {
            $searchItem = $('<li class="select-search-item"><input type="text" class="select-search-input" placeholder="Suchen…" autocomplete="off" /></li>').prependTo($list);
            $searchInput = $searchItem.find('input');
            $searchItem.on('click', function (e) {
              e.stopPropagation();
            });
            $searchInput.on('input', function () {
              var term = $(this).val().toLowerCase();
              $list.children('li').not($searchItem).each(function () {
                $(this).toggle($(this).text().toLowerCase().indexOf(term) !== -1);
              });
            });
          }

          var $listItems = $list.children('li').not('.select-search-item');

          $styledSelect.click(function (e) {
            e.stopPropagation();
            $('div.select-styled.active').not(this).each(function () {
              $(this).removeClass('active').next('ul.select-options').hide();
            });
            $(this).toggleClass('active').next('ul.select-options').toggle();
            if ($searchInput.length && $(this).hasClass('active')) {
              setTimeout(function () {
                $searchInput.trigger('focus');
              }, 0);
            }
          });

          $listItems.click(function (e) {
            e.stopPropagation();
            $styledSelect.text($(this).text()).removeClass('active');
            $this.val($(this).attr('rel')).trigger('change').blur();
            $list.hide();
            // Reset the search so all options are visible next time.
            if ($searchInput.length) {
              $searchInput.val('');
              $list.children('li').show();
            }
            if ($this.closest('form.views-exposed-form').length > 0) {
              $this.closest('form.views-exposed-form').find('.form-actions input[type=submit]').click();
            }
          });


        });
      }
      //-------selectbox --------------------------


      //------- selectboxes nettie-finder big --------------------------

      var select = $('select[name^=handlungsfelder]:not(.select-hidden), select[name^=bildungsabschnitte]:not(.select-hidden), select[name^="aktionsradius[]"]:not(.select-hidden)');

      if (select.length > 0) {
        $(select).each(function () {
          var $this = $(this), numberOfOptions = $(this).children('option').length;
          var elSelectedCount = $this.children('option[selected=selected]').length;
          var nameEl = capitalizeFirstLetter($this.attr('name').replace("[]", ""));

          if (elSelectedCount == 1) {
            if (nameEl == "Handlungsfelder") {
              nameEl = "Handlungsfeld";
            }
            if (nameEl == "Bildungsabschnitte") {
              nameEl = "Bildungsabschnitt";
            }
            nameEl = elSelectedCount + " " + nameEl;
          } else if (elSelectedCount > 1) {
            if (nameEl == "Aktionsradius") {
              nameEl = "Aktionsradien";
            }
            nameEl = elSelectedCount + " " + nameEl;
          }

          $this.addClass('select-hidden');
          $this.wrap('<div class="select multi"></div>');
          $this.after('<div class="select-styled">' + nameEl + '</div>');

          var $styledSelect = $this.next('div.select-styled');

          if (elSelectedCount > 0) {
            $styledSelect.addClass("yellowFix");
          }

          var $listBox = $('<div />', {
            'class': 'select-options very-big'
          }).insertAfter($styledSelect);

          var $list = $('<ul />', {
            'class': 'listBox'
          }).appendTo($listBox);

          for (var i = 0; i < numberOfOptions; i++) {
            var labelText = $this.children('option').eq(i).text();
            $('<li />', {
              html: '<div><label for="' + labelText + '" class="option special-checkbox">' + labelText + '</label>',
              rel: $this.children('option').eq(i).val()
            }).appendTo($list).click(function () {
              var _that = $(this);
              var label = _that.find('label');
              var elText = _that.attr("rel");
              var checked = label.hasClass("checked");
              $this.find("option[value='" + elText + "']").prop("selected", !checked);
              label.toggleClass("checked");
              var elSelectedCount = $this.parent().find('label.checked').length;
              var nameEl = capitalizeFirstLetter($this.attr('name').replace("[]", ""));
              if (elSelectedCount > 0) {
                $styledSelect.addClass('yellowFix');
              } else {
                $styledSelect.removeClass('yellowFix');
              }
              if (elSelectedCount == 1) {
                if (nameEl == "Handlungsfelder") {
                  nameEl = "Handlungsfeld";
                }
                if (nameEl == "Bildungsabschnitte") {
                  nameEl = "Bildungsabschnitt";
                }
                nameEl = elSelectedCount + " " + nameEl;
              } else if (elSelectedCount > 1) {
                if (nameEl == "Aktionsradius") {
                  nameEl = "Aktionsradien";
                }
                nameEl = elSelectedCount + " " + nameEl;
              }
              $styledSelect.text(nameEl);
            });
          }

          $this.children('option[selected=selected]').each(function (i, e) {
            var elText = $(this).val();
            $listBox.find('li[rel="' + elText + '"] label').addClass("checked");
          });

          $('<input />', {
            'class': 'button white block js-form-submit form-submit',
            'type': 'submit',
            'value': "Anwenden"
          }).appendTo($listBox);

          $styledSelect.click(function (e) {
            $('.overlayerSelector').toggle();
            e.stopPropagation();
            $('div.select-styled.active').not(this).each(function () {
              $(this).removeClass('active').removeClass('yellow').next('.select-options').hide();
            });
            $(this).toggleClass('active').toggleClass('yellow').next('.select-options').toggle();
          });
        });
      }
      //------- selectboxes nettie-finder big ---------------------------

    }
  };

  $(document).ready(function () {
      $(document).on("tap click", 'label a', function (event, data) {
        event.stopPropagation();
        event.preventDefault();
        window.open($(this).attr('href'), $(this).attr('target'));
        return false;
      });

      var slider = $('.slick-slider');
      slider.slick({});

      $(".menuContainer .fa-search").on("click", function () {
        var inputField = $(".search form input[type='text']");
        if (inputField.hasClass("focused")) {
          $(".search form").submit();
        } else {
          inputField.addClass('focused');
        }
        inputField.select();
      });

      $(".search form input[type='text']").blur(function () {
        var inputField = $(".search form input[type='text']");
        setTimeout(function () {
          inputField.removeClass('focused');
        }, 100);
      });

      $('.paragraph--type--galerie .fa-angle-left').on('click', function () {
        slider.slick('slickPrev');
      });
      $('.paragraph--type--galerie .fa-angle-right').on('click', function () {
        slider.slick('slickNext');
      });

      $('#nettiefinderfilter .js-form-item-suche .fa-search').click(function () {
        $(this).parents('form').submit();
      });

      //-----selectboxes nettie-finder-----
      var selectsStyled = $('.select-styled.custom');
      selectsStyled.click(function (e) {
        $('.overlayerSelector').toggle();
        e.stopPropagation();
        $('div.select-styled.active').not(this).each(function () {
          $(this).removeClass('active').removeClass('yellow').next('.select-options').hide();
        });
        $(this).toggleClass('active').toggleClass('yellow').next('.select-options').toggle();
      });
      selectsStyled.next().find('li').click(function () {
        var _that = $(this);
        var label = _that.find('label');
        if (!label.hasClass('disabled')) {
          var elText = _that.attr("rel");
          var checked = label.hasClass("checked");
          _that.closest('.select').find("select option[value='" + elText + "']").prop("selected", !checked);
          label.toggleClass("checked");
          if (elText == "bundesweit") {
            //console.log("test");
            _that.closest('.select').find('li').not(_that).find('label').removeClass('checked');
            _that.closest('.select').find("select option").not("[value='" + elText + "']").prop('selected', false);
            if (label.hasClass('checked')) {
              _that.closest('.select').find('li').not(_that).find('label').addClass('disabled');
            } else {
              _that.closest('.select').find('li').not(_that).find('label').removeClass('disabled');
            }
          }
        }
      });
      selectsStyled.each(function () {
        var __that = $(this);
        var labelBundesweit = __that.next().find('li label[for="bundesweit"].checked');
        if (labelBundesweit.length > 0) {
          __that.next().find('li label').not(labelBundesweit).removeClass("checked");
          __that.next().find('li label').not(labelBundesweit).addClass("disabled");
        }
      });
      selectsStyled.next().find('input[type="text"]').on("input", function () {
        var _that = $(this);
        var val = _that.val().toLowerCase();
        _that.parent().next(".listBox").find("li").hide();
        _that.parent().next(".listBox").find("label:contains(" + val + ")").closest("li").show();
      });

      //show hidden region-dropdowns
      $('.form-item-aktionsradius select').children('option[selected=selected]').each(function (i, e) {
        var elText = $(e).val();
        if (elText != "bundesweit") {
          $('.extraFilterWrapperOuter strong').addClass("show");
        }
        var elements = $('div[class*="form-item-aktionsradius-"]').find('label:text("' + elText + '")').closest('div[class*=form-item-aktionsradius]');
        elements.addClass('show');
      });
      //-----ende: selectboxes nettie-finder-----

      $(document).on("click", ".moreFilters", function () {
        var extraFilters = $('.extrafilters');
        var extraFilterWrapper = $('.extraFilterWrapper');
        var extraFilterWrapperOuter = $('.extraFilterWrapperOuter');
        extraFilters.toggleClass("open");
        if (!extraFilters.hasClass('open')) {
          extraFilterWrapperOuter.removeClass('shower');
          extraFilters.height(extraFilterWrapper.get(0).scrollHeight);
          extraFilters.animate({
            height: 0
          }, {
            duration: 500,
            queue: false,
            easing: 'easeInOutSine',
            step: function () {
              extraFilters.css("overflow", "visible");
            }
          });
          Cookies.set('exposedFilterSpecial', '');
        } else {
          extraFilters.height(0);
          extraFilters.animate({
            height: extraFilterWrapper.get(0).scrollHeight
          }, {
            duration: 500,
            queue: false,
            easing: 'easeInOutSine',
            step: function () {
              extraFilters.css("overflow", "visible");
            },
            complete: function () {
              $(this).height('auto');
              extraFilterWrapperOuter.addClass('shower');
            }
          });
          Cookies.set('exposedFilterSpecial', 'open');
        }
      });

      $(document).click(function (e) {
        var multiValueLength = $(e.target).closest('.select.multi').length;
        if (multiValueLength < 1) {
          $('div.select-styled').removeClass('active').removeClass('yellow');
          $('.select-options').hide();
          $('.overlayerSelector').hide();
        }
      });


      $(document).on("click", ".tabulators .item", function () {
        if($(this).attr('class').indexOf('map-disabled') === -1) {
          $('.tabulators .item').removeClass('active');
          $(this).addClass("active");
          var activeView = $(this).attr("data-item");
          $('.tab-view').removeClass('active');
          $('.tab-view.' + activeView).addClass("active");
          Cookies.set('activeNettieFilterTab', activeView);
          Cookies.set('activeAktionsFilterTab', activeView);
          if (activeView == "list") {
            $('.sorter').addClass('active');
          } else {
            $('.sorter').removeClass('active');
          }
        }
      });

      $(document).on("click", ".tabulators .sorter", function () {
        var _that = $(this);
        _that.find("ul").toggleClass('open');
      });

      $(document).on("click", ".tabulators .sorter .sort-selector li", function () {
        var _that = $(this);
        var formSubmit = $('form#views-exposed-form-nettie-finder-page-1 .form-actions > input[type="submit"]');
        if (_that.attr('data-sort') == "abisz") {
          $('#edit-sort-by').val('field_stiftung_organisation').change();
          $('#edit-sort-order').val('ASC').change();
          Cookies.set('nettieFilterSortBy', 'field_stiftung_organisation');
          Cookies.set('nettieFilterSortOrder', 'ASC');
          formSubmit.click();
        }
        if (_that.attr('data-sort') == "zbisa") {
          $('#edit-sort-by').val('field_stiftung_organisation').change();
          $('#edit-sort-order').val('DESC').change();
          Cookies.set('nettieFilterSortBy', 'field_stiftung_organisation');
          Cookies.set('nettieFilterSortOrder', 'DESC');
          formSubmit.click();
        }
        if (_that.attr('data-sort') == "relevanz") {
          $('#edit-sort-by').val('search_api_relevance').change();
          $('#edit-sort-order').val('DESC').change();
          Cookies.set('nettieFilterSortBy', 'search_api_relevance');
          Cookies.set('nettieFilterSortOrder', 'DESC');
          formSubmit.click();
        }
      });

      //--- FAQ --- Accordion ----
      // var faqQuestion = $('.faq-question');
      var faqQuestion = $('.question-title');
      $(faqQuestion).on('click touch', function () {
        var parent = $(this).closest('.faq-question');
        if (parent.hasClass('open')) {
          parent.find('.faq-answer').slideUp();
          parent.removeClass('open');
        } else {
          var faqAnswer = parent.find('.faq-answer');
          faqAnswer.slideDown();
          parent.addClass('open');
          $('.faq-answer').not(faqAnswer).slideUp();
          $('.faq-question').not(parent).removeClass('open');
        }
      });
      // ---

      //mobile menu opener
      $(document).on('click touch', ".menu_mobile_wrapper", function () {
        $("body,#header,.menu-button").toggleClass("menu-is-open");
      });
      // ---

      // Detailseite Anchor-Scrolling
      $(document).on('click touch', "a[href^='#']", function () {
        var that = $(this);
        var idScroll = that.attr('href');
        var offset = 20;
        var bodyOffset = parseInt($('body').css('paddingTop'));
        var headerOffset = parseInt($('#header').outerHeight());
        var offsetTotal = offset + bodyOffset + headerOffset;
        $('html,body').animate({scrollTop: ($(idScroll).offset().top - offsetTotal)}, 'slow');
        return false;
      });
      // ---

      var onAutoFillStart = function (el) {
        $(el).closest('.form-item').addClass("notempty");
      };
      var onAutoFillCancel = function (el) {
        $(el).closest('.form-item').removeClass("notempty");
      };

      PrefixedEvent(document.querySelectorAll('input'), "AnimationStart", AnimationListener);

      function AnimationListener(obj) {
        switch (obj.animationName) {
          case 'onAutoFillStart':
            return onAutoFillStart(obj.target);
          case 'onAutoFillCancel':
            return onAutoFillCancel(obj.target);
        }
      }

      function PrefixedEvent(elements, type, callback) {
        [].forEach.call(elements, function (el) {
          for (var p = 0; p < pfx.length; p++) {
            if (!pfx[p]) type = type.toLowerCase();
            el.addEventListener(pfx[p] + type, callback, false);
          }
        });
      }
    }//document ready
  );//document ready
  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  $("#edit-suche").keypress(function (event) {
    if (event.which === 13) {
      event.preventDefault();
      $('#edit-suche').parents('form').submit();
    }
  });

  const resetButton = $('#edit-reset-nettie-finder');
  resetButton.appendTo('#filterDelete');
  $("<p id='x-char-filter'>&#10005;</p>").prependTo('#filterDelete');

  resetButton.click(function (e) {
    const form = $('#views-exposed-form-nettie-finder-page-1');
    e.preventDefault();
    form.find('select option').prop('selected', false);
    form.find('input[type="text"], input[type="search"], input[type="email"], input[type="password"], input[type="number"], input[type="url"], input[type="tel"], input[type="date"], textarea').val('');
    resetButton.parents('form').submit();
    $('#filterDelete').css({"opacity": "0"});
  });
  if (resetButton.length > 0) {
    $('#filterDelete').css({"display": "block"});
  }

})(jQuery, Drupal);
